"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var DropdownSelect_1 = require("./dropdownSelect/DropdownSelect");
var InputField_1 = require("./inputField/InputField");
var CustomCheckbox_1 = require("./customCheckbox/CustomCheckbox");
var DatePicker_1 = require("./dateField/DatePicker");
var InputFieldWithHyphen_1 = require("./inputFieldWithHyphen/InputFieldWithHyphen");
var AutocompleteInput_1 = require("./autocompleteInput/AutocompleteInput");
var PhoneWIthPrefixInput_1 = require("./phoneWithPrefixField/PhoneWIthPrefixInput");
var CustomComponentsMapper = function () {
    return {
        TextWidget: function (inputData) { return <InputField_1.default formData={inputData}/>; },
        SelectWidget: function (selectData) { return <DropdownSelect_1.default formData={selectData}/>; },
        CheckboxWidget: function (checkboxData) { return <CustomCheckbox_1.CustomCheckbox formData={checkboxData}/>; },
        EmailWidget: function (emailData) { return <InputField_1.default formData={emailData}/>; },
        DateWidget: function (dateData) { return <DatePicker_1.default formData={dateData}/>; },
        InputWithHyphen: function (inputData) { return <InputFieldWithHyphen_1.default formData={inputData}/>; },
        Autocomplete: function (inputData) { return <AutocompleteInput_1.default formData={inputData}/>; },
        PhoneWithPrefix: function (inputData) { return <PhoneWIthPrefixInput_1.default formData={inputData}/>; },
    };
};
exports.default = CustomComponentsMapper;
